import { Box } from '@mantine/core';
import { TranscriptSegment } from './TranscriptSegment';
import type { TranscriptSegment as TranscriptSegmentType } from './types';

type Props = {
  segments: TranscriptSegmentType[];
  selectedIndex: number | null;
  onSegmentClick: (index: number) => void;
};

export const TranscriptSegmentsList = ({ segments, selectedIndex, onSegmentClick }: Props) => {
  return (
    <Box style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
      {segments.map((segment, index) => (
        <TranscriptSegment
          key={index}
          segment={segment}
          selected={selectedIndex === index}
          onClick={() => onSegmentClick(index)}
        />
      ))}
    </Box>
  );
};
